import {
  TASK_CREATED,
  TASK_UPDATED,
  TASK_REMOVED,
  TASKS_FROM_SERVER
} from "../actions/types";

/**
 * Reduces incoming planer actions to a new state
 *
 * @param {*} state
 * @param {*} action
 */
export default function planer(state = {}, action = {}) {
  const tasks = state.tasks || [];
  switch (action.type) {
    /**
     * Replaces the task list with the one received
     * from the server
     */
    case TASKS_FROM_SERVER:
      return {
        ...state,
        tasks: action.tasks
      };
    /**
     * Adds a newly created task to the local task list
     */
    case TASK_CREATED:
      return { ...state, tasks: [...tasks, action.task] };
    /**
     * Updates a given task in the local task list using
     * an updated server-side task
     */
    case TASK_UPDATED:
      return {
        ...state,
        tasks: tasks.map(task => {
          if (task.id === action.task.id) {
            return action.task;
          }
          return task;
        })
      };
    /**
     * Removes a task locally
     */
    case TASK_REMOVED:
      return {
        ...state,
        tasks: tasks.filter(task => task.id !== action.id)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/planer.js